import React, { Component } from 'react';

export default class CalendarCell extends Component {
    render() {
        let cellClasses = 'cell';
        const { date, end, start } = this.props;
        const worktime = `${start} ~ ${end}`;
        const isStarted = start && start.length > 0;
        const isCompleted = isStarted && end && end.length > 0;

        if (isCompleted) {
            cellClasses += ' completed';
        } else if (isStarted) {
            cellClasses += ' started';
        }

        return (
            <div className={cellClasses} onClick={this.props.onClick}>
                <span className="date-label">{date}</span>
                {(() => {
                    if (isCompleted || isStarted) {
                        return <span className="date-worktime">{worktime}</span>;
                    }
                    return null;
                })()}
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/calendar/CalendarCell.js